/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Faq_Agent_AnswerInputs */

const en_landing_faq_agent_answer = /** @type {(inputs: Landing_Faq_Agent_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Inginuiti is AI-native infrastructure, not an agent. The core product is a governed data layer that any agent - Claude, ChatGPT, Perplexity, or your own tools - can query directly. We also offer Intelligence Hub, a ready-built interface for teams who would rather use ours than build their own, connected to your infrastructure during deployment.`)
};

/**
* | output |
* | --- |
* | "No. Inginuiti is AI-native infrastructure, not an agent. The core product is a governed data layer that any agent - Claude, ChatGPT, Perplexity, or your own ..." |
*
* @param {Landing_Faq_Agent_AnswerInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_faq_agent_answer = /** @type {((inputs?: Landing_Faq_Agent_AnswerInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Faq_Agent_AnswerInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_faq_agent_answer(inputs)
});